// customerHub.js

// TODO: Configuration
const COMPANY_ID = 'MZ2BBN';
const KLAVIYO_ORIGIN = 'https://static.klaviyo.com';
const SCRIPT_URL = `${KLAVIYO_ORIGIN}/onsite/js/${COMPANY_ID}/klaviyo.js`;

// --- Preload / prioritize Klaviyo so it fetches ASAP, even mid page-load ---
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = KLAVIYO_ORIGIN;
preconnect.crossOrigin = 'anonymous';
(document.head || document.documentElement).appendChild(preconnect);

const preload = document.createElement('link');
preload.rel = 'preload';
preload.as = 'script';
preload.href = SCRIPT_URL;
preload.crossOrigin = 'anonymous';
(document.head || document.documentElement).appendChild(preload);

// --- Load the Klaviyo onsite script immediately (no defer) ---
const script = document.createElement('script');
script.src = SCRIPT_URL;
script.async = true;
script.onload = () => { console.log('Klaviyo JS script loaded successfully'); };
script.onerror = () => { console.error('Failed to load Klaviyo JS script'); };
(document.head || document.documentElement).appendChild(script);

// --- Wait until Customer Hub is ready, then run a callback ---
function whenHubReady(cb) {
  if (window.customerHubApi && typeof window.customerHubApi.open === 'function') {
    cb();
    return;
  }
  requestAnimationFrame(() => whenHubReady(cb));
}

// --- Open the Hub directly from the account ICON button ---
function wireAccountIcon() {
  const btn = document.getElementById('LevoHeaderAccountTogglee');
  if (!btn || btn.dataset.khubWired) return;
  btn.dataset.khubWired = '1';
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    whenHubReady(() => window.customerHubApi.open());
  }, true);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', wireAccountIcon);
} else {
  wireAccountIcon();
}